import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faExclamationTriangle, faTimes, faUndo, faRocket } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-modal-confirm',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule, ButtonComponent],
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent {
  @Input() show = false;
  @Input() title = 'COMMON.CONFIRM';
  @Input() message = '';
  @Input() confirmLabel = 'BUTTON.CONFIRM';
  @Input() variant: 'primary' | 'warning' | 'danger' = 'primary';
  @Input() btnVariant: 'primary' | 'danger' = 'primary';
  @Input() icon: any = null;
  @Input() loading = false;

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  faExclamationTriangle = faExclamationTriangle;
  faTimes = faTimes;
  faUndo = faUndo;

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }
}
